module.exports = __webpack_public_path__ + "6e435a56a73d883e42ee63874b9f08f6.MP3";